export default "__VITE_ASSET__9d92d3b6__"